import { useComputed } from "@suse-o11y/signal";
import { useDelayed } from "@suse-o11y/use-delayed";
import type React from "react";

import { useTimelineContext } from "../_context";

import type { TimelineHoveredLine } from "./TimelineLineState";

const TIMELINE_LINE_POPOVER_HIDE_DELAY_MS = 500;

export const usePopoverLine = (): [undefined | TimelineHoveredLine, React.Dispatch<boolean>] => {
	const { lineState } = useTimelineContext();
	const hoveredLine = useComputed(lineState.hoveredLine);

	// it should delay the hovered line in a timeline to give a chance to hover the popover
	const delayedLine = useDelayed(hoveredLine, hoveredLine == null ? TIMELINE_LINE_POPOVER_HIDE_DELAY_MS : 0);

	return [
		useComputed((monitor) => lineState.getLinePopup(monitor), [lineState]) ?? delayedLine,
		(isHovered: boolean) => lineState.setLinePopup(isHovered ? delayedLine : undefined),
	];
};
